import {
  Band,
  GroupShell,
  LedgerHeader,
  Money,
  type LedgerCollapse,
} from '@billda/design-system';
import { POT, POT_ORG_DEDUCTIONS, type BookedRow } from './data';
import { SITE_COLUMNS } from './SiteLedgerDemo';
import { renderBookedRow } from './bookedRow';

/** Band totals exclude rejected and cancelled work. */
function bandTotal(rows: BookedRow[]): number {
  return rows
    .filter(row => row.status !== 'Cancelled' && row.status !== 'Rejected')
    .reduce((sum, row) => sum + row.amount, 0);
}

interface PotLedgerDemoProps {
  collapse: LedgerCollapse;
  onOpen: (label: string) => void;
}

export function PotLedgerDemo({ collapse, onOpen }: PotLedgerDemoProps) {
  const ctx = { columns: SITE_COLUMNS, collapse, onOpen };
  const orgTotal = POT_ORG_DEDUCTIONS.reduce((sum, row) => sum + row.amount, 0);

  return (
    <div>
      <LedgerHeader columns={SITE_COLUMNS} collapse={collapse} />
      {POT.sites.flatMap(site =>
        site.plots.map(plot => (
          <GroupShell
            key={`${site.name}-${plot.number}`}
            header={(open, toggle) => (
              <Band
                collapse={collapse}
                primary={site.name}
                secondary={`Plot ${plot.number}`}
                count={plot.rows.length}
                open={open}
                onToggle={toggle}
                trailing={<Money value={bandTotal(plot.rows)} />}
              />
            )}
          >
            {plot.rows.map(row => renderBookedRow(row, ctx))}
          </GroupShell>
        ))
      )}
      <GroupShell
        header={(open, toggle) => (
          <Band
            collapse={collapse}
            primary="Other deductions"
            count={POT_ORG_DEDUCTIONS.length}
            open={open}
            onToggle={toggle}
            trailing={<Money value={orgTotal} color="error.main" />}
          />
        )}
      >
        {POT_ORG_DEDUCTIONS.map(row => renderBookedRow(row, ctx))}
      </GroupShell>
    </div>
  );
}
